import { Link, useParams } from 'react-router-dom'

// サンプルデータ
const doctorData = {
  'doc-001': {
    id: 'doc-001',
    doctorCode: 'D001',
    lastName: '吉岡',
    firstName: '紘平',
    lastNameKana: 'ヨシオカ',
    firstNameKana: 'コウヘイ',
    hospitalId: 'hosp-001',
    hospitalName: 'Baseクリニック赤坂',
    userId: 'user-003',
    userEmail: 'yoshioka@base-clinic.jp',
    licenseNumber: '123456',
    specialty: '消化器内科',
    title: '院長',
    department: '消化器内科',
    email: 'yoshioka@base-clinic.jp',
    phone: '03-1234-5678',
    mobile: '090-1234-5678',
    canTransplant: true,
    canPrimaryCare: true,
    notes: 'FMT認定医',
    isActive: true,
    createdAt: '2023-04-01',
    updatedAt: '2025-11-01',
    recentPatients: [
      { id: 'pat-001', researchId: 'R01166', name: 'KuKn', disease: '潰瘍性大腸炎', lastVisit: '2025-11-28' },
      { id: 'pat-008', researchId: 'R01701', name: 'YmdTky', disease: 'うつ病', lastVisit: '2025-11-25' },
    ],
    recentReservations: [
      { id: 'res-001', date: '2025-11-28', patientName: 'KuKn', status: '完了' },
      { id: 'res-005', date: '2025-12-03', patientName: 'YmdTky', status: '受付済' },
    ],
  },
}

export default function DoctorDetail() {
  const { id } = useParams()
  const doctor = doctorData[id as keyof typeof doctorData] || doctorData['doc-001']

  return (
    <>
      <header className="aip-main__header">
        <div className="aip-main__header-container">
          <Link to="/master/doctors" className="aip-button aip-button--icon">
            <span className="material-symbols-outlined">arrow_back</span>
          </Link>
          <h1 className="aip-main__header-title">医師詳細</h1>
          <div className="aip-main__header-buttons">
            <Link to={`/master/doctors/${id}/edit`} className="aip-button aip-button--outline">
              <span className="material-symbols-outlined">edit</span>
              編集
            </Link>
          </div>
        </div>
      </header>

      <div className="aip-main__content">
        <div className="detail-container">
          {/* プロフィールヘッダー */}
          <div className="profile-header">
            <div className="profile-avatar">
              {doctor.lastName.charAt(0)}
            </div>
            <div className="profile-info">
              <h2 className="profile-name">{doctor.lastName} {doctor.firstName}</h2>
              <span className="profile-kana">{doctor.lastNameKana} {doctor.firstNameKana}</span>
              <div className="profile-badges">
                <span className="aip-badge aip-badge--primary">{doctor.title}</span>
                <span className="aip-badge aip-badge--info">{doctor.specialty}</span>
                {doctor.canTransplant && (
                  <span className="aip-badge aip-badge--success">移植担当可</span>
                )}
              </div>
            </div>
          </div>

          {/* 基本情報 */}
          <section className="detail-section">
            <h2 className="detail-section__title">基本情報</h2>
            <div className="detail-grid">
              <div className="detail-field">
                <label className="detail-field__label">医師コード</label>
                <span className="detail-field__value">{doctor.doctorCode}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">医師免許番号</label>
                <span className="detail-field__value">{doctor.licenseNumber}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">専門分野</label>
                <span className="detail-field__value">{doctor.specialty}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">役職</label>
                <span className="detail-field__value">{doctor.title}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">診療科</label>
                <span className="detail-field__value">{doctor.department}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">状態</label>
                <span className={`aip-badge aip-badge--${doctor.isActive ? 'success' : 'neutral'}`}>
                  {doctor.isActive ? '有効' : '無効'}
                </span>
              </div>
            </div>
          </section>

          {/* 所属病院 */}
          <section className="detail-section">
            <h2 className="detail-section__title">所属病院</h2>
            <Link to={`/master/hospitals/${doctor.hospitalId}`} className="hospital-card">
              <span className="material-symbols-outlined hospital-card__icon">local_hospital</span>
              <div className="hospital-card__info">
                <span className="hospital-card__name">{doctor.hospitalName}</span>
                <span className="hospital-card__link">詳細を見る →</span>
              </div>
            </Link>
          </section>

          {/* 担当権限 */}
          <section className="detail-section">
            <h2 className="detail-section__title">担当権限</h2>
            <div className="permission-grid">
              <div className={`permission-item ${doctor.canTransplant ? 'permission-item--active' : ''}`}>
                <span className="material-symbols-outlined">
                  {doctor.canTransplant ? 'check_circle' : 'cancel'}
                </span>
                <span>移植担当</span>
              </div>
              <div className={`permission-item ${doctor.canPrimaryCare ? 'permission-item--active' : ''}`}>
                <span className="material-symbols-outlined">
                  {doctor.canPrimaryCare ? 'check_circle' : 'cancel'}
                </span>
                <span>主治医担当</span>
              </div>
            </div>
          </section>

          {/* 連絡先 */}
          <section className="detail-section">
            <h2 className="detail-section__title">連絡先</h2>
            <div className="detail-grid">
              <div className="detail-field">
                <label className="detail-field__label">メールアドレス</label>
                <a href={`mailto:${doctor.email}`} className="detail-field__link">{doctor.email}</a>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">電話番号</label>
                <a href={`tel:${doctor.phone}`} className="detail-field__link">{doctor.phone}</a>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">携帯電話</label>
                <span className="detail-field__value">{doctor.mobile || '-'}</span>
              </div>
            </div>
          </section>

          {/* ログインアカウント */}
          <section className="detail-section">
            <h2 className="detail-section__title">ログインアカウント</h2>
            <div className="account-card">
              <span className="material-symbols-outlined account-card__icon">account_circle</span>
              <div className="account-card__info">
                <span className="account-card__email">{doctor.userEmail}</span>
                <span className="account-card__id">User ID: {doctor.userId}</span>
              </div>
              <span className="aip-badge aip-badge--success">連携済</span>
            </div>
          </section>

          {/* 担当患者（最新） */}
          <section className="detail-section">
            <h2 className="detail-section__title">
              担当患者（最新）
              <Link to="/patients" className="section-link">すべて見る</Link>
            </h2>
            <div className="data-table-wrapper">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>研究会ID</th>
                    <th>氏名（子音）</th>
                    <th>病名</th>
                    <th>最終受診日</th>
                  </tr>
                </thead>
                <tbody>
                  {doctor.recentPatients.map((patient) => (
                    <tr key={patient.id}>
                      <td>
                        <Link to={`/patients/${patient.id}`} className="aip-table__link">
                          {patient.researchId}
                        </Link>
                      </td>
                      <td>{patient.name}</td>
                      <td>{patient.disease}</td>
                      <td>{patient.lastVisit}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          {/* 予約一覧（最新） */}
          <section className="detail-section">
            <h2 className="detail-section__title">
              予約一覧（最新）
              <Link to="/reservations" className="section-link">すべて見る</Link>
            </h2>
            <div className="data-table-wrapper">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>予約日</th>
                    <th>患者名</th>
                    <th>ステータス</th>
                  </tr>
                </thead>
                <tbody>
                  {doctor.recentReservations.map((reservation) => (
                    <tr key={reservation.id}>
                      <td>
                        <Link to={`/reservations/${reservation.id}`} className="aip-table__link">
                          {reservation.date}
                        </Link>
                      </td>
                      <td>{reservation.patientName}</td>
                      <td>
                        <span className={`aip-badge aip-badge--${reservation.status === '完了' ? 'success' : 'info'}`}>
                          {reservation.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          {/* 備考 */}
          <section className="detail-section">
            <h2 className="detail-section__title">備考</h2>
            <p className="detail-notes">{doctor.notes || '-'}</p>
          </section>

          {/* システム情報 */}
          <section className="detail-section detail-section--muted">
            <div className="detail-grid detail-grid--compact">
              <div className="detail-field">
                <label className="detail-field__label">登録日</label>
                <span className="detail-field__value">{doctor.createdAt}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">最終更新日</label>
                <span className="detail-field__value">{doctor.updatedAt}</span>
              </div>
            </div>
          </section>
        </div>

        {/* アクションバー */}
        <div className="action-bar">
          <Link to="/master/doctors" className="aip-button aip-button--outline">
            戻る
          </Link>
          <div className="action-bar__right">
            <button className="aip-button aip-button--outline aip-button--alert">
              <span className="material-symbols-outlined">delete</span>
              削除
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .detail-container {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-lg);
        }

        .profile-header {
          display: flex;
          align-items: center;
          gap: var(--spacing-lg);
          padding: var(--spacing-xl);
          background: linear-gradient(135deg, var(--color-blue50) 0%, var(--background-primary) 100%);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-sm);
        }

        .profile-avatar {
          width: 100px;
          height: 100px;
          border-radius: var(--border-radius-lg);
          background-color: var(--color-blue500);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2.5rem;
          font-weight: 600;
        }

        .profile-info {
          flex: 1;
        }

        .profile-name {
          font-size: 1.5rem;
          font-weight: 600;
          margin-bottom: 4px;
        }

        .profile-kana {
          font-size: 0.875rem;
          color: var(--text-secondary);
          display: block;
          margin-bottom: var(--spacing-sm);
        }

        .profile-badges {
          display: flex;
          gap: var(--spacing-xs);
          flex-wrap: wrap;
        }

        .detail-section {
          background-color: var(--background-primary);
          padding: var(--spacing-lg);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-sm);
        }

        .detail-section--muted {
          background-color: var(--color-solid-gray25);
        }

        .detail-section__title {
          font-size: 1rem;
          font-weight: 600;
          margin-bottom: var(--spacing-md);
          padding-bottom: var(--spacing-sm);
          border-bottom: 1px solid var(--border-color);
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .section-link {
          font-size: 0.75rem;
          font-weight: 400;
          color: var(--color-blue600);
        }

        .detail-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: var(--spacing-md);
        }

        .detail-grid--compact {
          grid-template-columns: repeat(2, 1fr);
        }

        .detail-field {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-xs);
        }

        .detail-field__label {
          font-size: 0.75rem;
          color: var(--text-secondary);
        }

        .detail-field__value {
          font-size: 0.875rem;
          color: var(--text-primary);
        }

        .detail-field__link {
          font-size: 0.875rem;
          color: var(--color-blue600);
        }

        .detail-field__link:hover {
          text-decoration: underline;
        }

        .detail-notes {
          font-size: 0.875rem;
          line-height: 1.6;
        }

        .hospital-card {
          display: flex;
          align-items: center;
          gap: var(--spacing-md);
          padding: var(--spacing-md);
          background-color: var(--color-solid-gray25);
          border-radius: var(--border-radius-md);
          text-decoration: none;
          color: inherit;
          transition: background-color 0.2s;
        }

        .hospital-card:hover {
          background-color: var(--color-solid-gray100);
        }

        .hospital-card__icon {
          font-size: 2rem;
          color: var(--color-blue600);
        }

        .hospital-card__info {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .hospital-card__name {
          font-weight: 500;
        }

        .hospital-card__link {
          font-size: 0.75rem;
          color: var(--color-blue600);
        }

        .permission-grid {
          display: flex;
          gap: var(--spacing-md);
        }

        .permission-item {
          display: flex;
          align-items: center;
          gap: var(--spacing-sm);
          padding: var(--spacing-sm) var(--spacing-md);
          background-color: var(--color-solid-gray100);
          border-radius: var(--border-radius-md);
          color: var(--text-secondary);
        }

        .permission-item--active {
          background-color: var(--color-success-light);
          color: var(--color-success);
        }

        .permission-item .material-symbols-outlined {
          font-size: 20px;
        }

        .account-card {
          display: flex;
          align-items: center;
          gap: var(--spacing-md);
          padding: var(--spacing-md);
          background-color: var(--color-solid-gray25);
          border-radius: var(--border-radius-md);
        }

        .account-card__icon {
          font-size: 2rem;
          color: var(--color-blue600);
        }

        .account-card__info {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .account-card__email {
          font-weight: 500;
        }

        .account-card__id {
          font-size: 0.75rem;
          color: var(--text-secondary);
        }

        .data-table-wrapper {
          overflow-x: auto;
        }

        .data-table {
          width: 100%;
          border-collapse: collapse;
        }

        .data-table th,
        .data-table td {
          padding: var(--spacing-sm) var(--spacing-md);
          text-align: left;
          border-bottom: 1px solid var(--border-color);
          font-size: 0.875rem;
        }

        .data-table th {
          font-weight: 500;
          font-size: 0.75rem;
          color: var(--text-secondary);
          background-color: var(--color-solid-gray25);
        }

        .aip-table__link {
          color: var(--color-blue600);
        }

        .aip-table__link:hover {
          text-decoration: underline;
        }

        .aip-badge {
          display: inline-block;
          padding: 4px 12px;
          font-size: 0.75rem;
          font-weight: 500;
          border-radius: var(--border-radius-sm);
        }

        .aip-badge--primary {
          background-color: var(--color-blue100);
          color: var(--color-blue700);
        }

        .aip-badge--success {
          background-color: var(--color-success-light);
          color: var(--color-success);
        }

        .aip-badge--info {
          background-color: var(--color-blue50);
          color: var(--color-blue600);
        }

        .aip-badge--neutral {
          background-color: var(--color-solid-gray100);
          color: var(--color-solid-gray700);
        }

        .action-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: var(--spacing-lg);
          padding: var(--spacing-md);
          background-color: var(--background-primary);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-sm);
        }

        .action-bar__right {
          display: flex;
          gap: var(--spacing-sm);
        }

        .aip-button--alert {
          color: var(--color-alert);
          border-color: var(--color-alert);
        }

        .aip-button--alert:hover {
          background-color: var(--color-alert-light);
        }

        @media (max-width: 768px) {
          .profile-header {
            flex-direction: column;
            text-align: center;
          }

          .profile-badges {
            justify-content: center;
          }

          .permission-grid {
            flex-direction: column;
          }
        }
      `}</style>
    </>
  )
}




